import { lazy, Suspense } from "react";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { MotionConfig } from "motion/react";

import { AnalyticsRouteListener } from "@/components/analytics-route-listener";
import { LandingPage } from "@/components/landing/landing-page";

const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-router-devtools").then((mod) => ({
        default: mod.TanStackRouterDevtools,
      })),
    )
  : () => null;

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: LandingPage,
});

function RootLayout() {
  return (
    <MotionConfig reducedMotion="user">
      <AnalyticsRouteListener />
      <Outlet />
      {import.meta.env.DEV ? (
        <Suspense fallback={null}>
          <TanStackRouterDevtools />
        </Suspense>
      ) : null}
    </MotionConfig>
  );
}
